module.exports = __webpack_public_path__ + "static/media/add_doctor.19aff463.svg";